<mat-accordion *ngIf="!isNotExpandable; else notExpandableElseBlock">
  <mat-expansion-panel hideToggle [expanded]="toggleChanged" (opened)="toggleChanged = true"
    (closed)="toggleChanged = false">

    <mat-expansion-panel-header>
      <mat-panel-title class="atp-filters-panel__header-container_expandable">
        <h3 class="atp-filters-panel__header" *ngIf="label">{{label}}</h3>
        <mat-icon [@OpenClose]="toggleChanged ? 'opened' : 'closed'">keyboard_arrow_down</mat-icon>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ng-template [ngTemplateOutlet]="formTemplate"></ng-template>

  </mat-expansion-panel>
</mat-accordion>

<ng-template #notExpandableElseBlock>
  <h3 class="atp-filters-panel__header" *ngIf="label">{{label}}</h3>
  <ng-template [ngTemplateOutlet]="formTemplate"></ng-template>
</ng-template>

<ng-template #formTemplate>
  <form (ngSubmit)="filtrationClick()" novalidate>
    <div class="atp-filters-panel__content">
      <ng-template [ngTemplateOutlet]="formGroup" [ngTemplateOutletContext]="{item: {items: items}}">
      </ng-template>
    </div>

    <div class="atp-filters-panel__section_actions">
      <button mat-raised-button color="primary" type="submit">{{filteringButtonLabel ? filteringButtonLabel :
        'Отфильтровать'}}</button>
      <button mat-raised-button color="warn" type="button" (click)="resetClick()">{{clearButtonLabel ? clearButtonLabel
        : 'Сброс'}}</button>
    </div>
  </form>
</ng-template>

<ng-template #formGroup let-item="item">
  <ng-container *ngFor="let groupItem of item.items">

    <div *ngIf="groupItem.type == 'Group'; else elseGroup"
      [class]="'atp-filters-panel__group atp-filters-panel__group_' + groupItem.name.toLowerCase()">
      <h4 class="atp-filters-panel__group-header" *ngIf="groupItem.display">{{groupItem.display}}</h4>

      <div class="atp-filters-panel__group-content">
        <ng-template [ngTemplateOutlet]="formGroup" [ngTemplateOutletContext]="{item: groupItem}">
        </ng-template>
      </div>
    </div>
    <ng-template #elseGroup [ngTemplateOutlet]="getTemplateRef({ Boolean: booleanFormControl, String: stringFormControl,
      DateTime: dateTimeFormControl, Select: selectFormControl }, groupItem.type)"
      [ngTemplateOutletContext]="{item: groupItem}">
    </ng-template>

  </ng-container>
</ng-template>

<ng-template #booleanFormControl let-item="item">
  <ng-container [formGroup]="form">
    <mat-checkbox class="atp-filters-panel__form-field atp-filters-panel__form-field_checkbox" color="primary"
      [formControlName]="item.name" [name]="item.name">
      {{item.display ? item.display : item.name}}
    </mat-checkbox>
  </ng-container>
</ng-template>

<ng-template #stringFormControl let-item="item">
  <ng-container [formGroup]="form">
    <mat-form-field *ngIf="item.mask; else masksElseBlock"
      [class]="'atp-filters-panel__form-field atp-filters-panel__form-field_' + item.name.toLowerCase()"
      appearance="outline">
      <mat-label>{{item.display ? item.display : item.name}}</mat-label>
      <input #stringInputElement matInput [textMask]="{mask: item.mask, guide: false, keepCharPositions: true}"
        [formControlName]="item.name" [name]="item.name">
      <button *ngIf="stringInputElement.value" matSuffix mat-icon-button type="button"
        (click)="form.controls[item.name].setValue('')">
        <mat-icon color="warn">close</mat-icon>
      </button>
    </mat-form-field>
    <ng-template #masksElseBlock>
      <mat-form-field *ngIf="!item.mask"
        [class]="'atp-filters-panel__form-field atp-filters-panel__form-field_' + item.name.toLowerCase()"
        appearance="outline">
        <mat-label>{{item.display ? item.display : item.name}}</mat-label>
        <input #stringInputElement matInput [formControlName]="item.name" [name]="item.name">
        <button *ngIf="stringInputElement.value" matSuffix mat-icon-button type="button"
          (click)="form.controls[item.name].setValue('')">
          <mat-icon color="warn">close</mat-icon>
        </button>
      </mat-form-field>
    </ng-template>
  </ng-container>

</ng-template>

<ng-template #dateTimeFormControl let-item="item">
  <mat-form-field [formGroup]="form"
    [class]="'atp-filters-panel__form-field atp-filters-panel__form-field_datetime atp-filters-panel__form-field_' + item.name.toLowerCase()"
    appearance="outline">
    <mat-label>{{item.display ? item.display : item.name}}</mat-label>
    <atp-range-date-time-picker type="RangeDateTime" isFilter="true" [formControlName]="item.name">
    </atp-range-date-time-picker>
    <button matSuffix mat-icon-button (click)="form.controls[item.name].setValue([null, null])" type="button">
      <mat-icon color="warn">close</mat-icon>
    </button>
  </mat-form-field>
</ng-template>

<ng-template #selectFormControl let-item="item">
  <mat-form-field [formGroup]="form"
    [class]="'atp-filters-panel__form-field atp-filters-panel__form-field_' + item.name.toLowerCase()"
    appearance="outline">
    <mat-label>{{item.display ? item.display : item.name}}</mat-label>
    <mat-select [formControlName]="item.name">
      <mat-option>Все</mat-option>
      <mat-option *ngFor="let option of item.options" [value]="option">
        {{option.value}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>